export default {
  baseURL: 'https://api.frontm.ai',
  filesAPI: 'https://gw.frontm.ai/proxy/resource',
  contentURL: 'https://gw.frontm.ai/proxy/botLogos/',
  botFilesAPI: 'https://gw.frontm.ai/proxy/resource/botfile?path=',
  paymentGatewayKey: process.env.REACT_APP_PAYMENT_GATEWAY_KEY,
  soundURL: 'https://gw.frontm.ai/proxy/sounds/',
  gRPCURL: 'https://gw.frontm.ai',
  webertcSignalServer: 'gw.frontm.ai',
  mapURL: 'https://maps.frontm.ai/styles/klokantech-basic/style.json',
  sipURI: 'frontmsecureweb@pstn-prod.frontm.ai',
  sipPassword: process.env.REACT_APP_SIP_PASSWORD,
  sipWebsocket: 'wss://pstn-prod.frontm.ai:8089/ws',
};
